import Vue from "vue";
import Printer from "vue-template-printer";

Vue.use(Printer);
